<template>
	<section class="Address">
		<Form :form="form" :data="formData" @change="onChange" />
		<Button :disabled="isDisabled()" @click="onSendAddress">送信する</Button>
	</section>
</template>

<script>
	export default {
		data() {
			return {
				form: [
					{
						name: 'zip',
						type: 'text',
						placeholder: ['199', '0000'],
						label: '郵便番号',
						maxlength: [3, 4]
					},
					{
						label: '住所１',
						name: 'addr1',
						type: 'text',
						placeholder: '〇〇市〇〇区〇〇町'
					},
					{
						label: '住所２',
						name: 'addr2',
						type: 'text',
						placeholder: '〇〇丁目マンション名'
					}
				],

				formData: {
					zip: ['', ''],
					addr1: '',
					addr2: ''
				}
			};
		},

		methods: {
			onChange(key, value) {
				this.formData[key] = value;
			},
			isDisabled() {
				return !(this.formData.zip.every(e => e) && this.formData.addr1 && this.formData.addr2);
			},
			onSendAddress() {
				const { zip, addr1, addr2 } = this.formData;
				this.$emit('send', { zip: zip.join('-'), addr1, addr2 });
			}
		}
	};
</script>

<style scoped lang="scss">
	.Address {
		padding: 1rem 1.6rem;
		max-width: 36rem;

		/deep/ .Form {
			.form-group {
				&[data-entry='zip'] {
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;

					.title {
						flex: 0 0 100%;
					}

					.input-area {
						margin-top: 0;

						&:first-of-type {
							flex: 0 1 8rem;
						}

						&:not(:first-of-type) {
							margin-left: 1rem;
							display: flex;
							align-items: center;
							flex: 0 1 12rem;

							&::before {
								content: '-';
								margin-right: 1rem;
							}
						}
					}
				}
			}
		}

		.Button {
			margin-top: 2rem;
			width: 100%;
		}
	}
</style>
